<template>
  <v-app>
    <Header ref="headerRef"/>
    <Sidebar />
    <v-main class="content mx-0 mx-md-2">
      <router-view></router-view>
      <Helper />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import MainService from "@/services/main/main.service.js";
import Security from "@/utils/security.vue.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Header from "@/views/shared/header/Header.vue";
import Footer from "@/views/shared/footer/footer.vue";
import Sidebar from "@/views/shared/sidebar/Sidebar.vue";
import Helper from "@/views/shared/helper/Helper.vue";
import Push from 'push.js';

export default {
  components: {
    Header,
    Sidebar,
    Helper,
    Footer,
        },
        data: () => {
            return {
                esPruebas: true,
                uslogin:''
            }

        },

  computed: {
    ...mapState(["user", "permission", "informationPage", "domain"]),
    ...mapGetters(["getUser"]),
  },
  methods: {
      ...mapMutations(["fillDataUser"]),
      loadNotification(m) {

          let self = this;
          Push.create(m.proceso, {
              body: m.mensaje,
              icon: 'https://www.ausa.com.mx/img/logo.png',
              onClick: function () {
                  self.NavigateToNoti(m.clave, m.enlace)
                  this.close();
              }
          });
      },
      NavigateToNoti(clave, enlace) {
          this.$refs.headerRef.Elimina(clave);
          setTimeout(function () {
                  window.open(enlace, '_blank');
          }, 1000);
      },
      async setCookie(name, value, days) {
          let expires = "";
          if (days) {
              const date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
        },
        sockets: {
            async AgregarNotificacion(message) {

                var time = (Math.floor(Math.random() * 9))*1000;
                
                setTimeout(async () => {
                    if (message.receptor == this.uslogin) {
                        this.$refs.headerRef.VerNoti();
                        this.$refs.headerRef.ObntenerNotificacion();
                    }
                    const notificationShown = await ManagerLocalStorage.getSingleValueInLocalStorage('notify');
                    if (!notificationShown) {
                        
                        if (message.receptor == this.uslogin) {


                                if (Push.Permission.has()) {
                                    this.loadNotification(message);
                                } 
                            await ManagerLocalStorage.addSingleLocalStorage('true', 'notify');
                            

                            
                            setTimeout(async () => {
                                await ManagerLocalStorage.removeLocalStorage('notify');
                            }, 10000);

                        }
                    }
                }, time);
                

                
            },
            async ActualizarNotify(message) {
                if (message.uslogin == this.uslogin) {
                    await this.$refs.headerRef.VerNoti();
                    await this.$refs.headerRef.ObntenerNotificacion();
                }
            }

        },
        created: async function () {
            MainService.serviceWorkerStart();
            this.fillDataUser(
                ManagerLocalStorage.getSingleValueInLocalStorage(
                    this.informationPage.nameLocalStoragePGV2
                )
            );
            let variables = await MetodosGenerales.variables(this);

            this.$socket.start({
                // Logging is optional but very helpful during development
            });
            let self = this;

            this.$socket.on("AgregarNotificacion", (message) => {
            });
            this.$socket.on("ActualizarNotify", (message) => {
            });
        },
        
        async mounted() {
    MetodosGenerales.registrarPaginaVisitada(this);
    Security.verifyGlobalPermission(
      this.getUser,
      this.permission.global,
      "noautorizado",
      this.$router,
      ManagerLocalStorage.getSingleValueInLocalStorage(
        this.informationPage.nameLocalStoragePGV2
      )
      );
      //this.esPruebas = MetodosGenerales.EsEntornoDePruebas();
            this.uslogin = ManagerLocalStorage.getSingleValueInLocalStorage(this.informationPage.nameLocalStoragePGV2);
  },
  beforeUpdate() {
    MetodosGenerales.registrarPaginaVisitada(this);
    Security.verifyGlobalPermission(
      this.getUser,
      this.permission.global,
      "noautorizado",
      this.$router,
      ManagerLocalStorage.getSingleValueInLocalStorage(
        this.informationPage.nameLocalStoragePGV2
      )
    );
  },
};
</script>
